module.exports = __webpack_public_path__ + "img/LR_Logo.806bfbf8.png";